var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uk-iconnav data-grid-actions uk-float-right"
  }, [_vm._t("before"), _vm._v(" "), (_vm.editable) ? _c('li', [(_vm.editRoute) ? _c('router-link', {
    attrs: {
      "to": _vm.editRoute
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1) : _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('edit')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.removable) ? _c('li', [(_vm.removeRoute) ? _c('router-link', {
    attrs: {
      "to": _vm.removeRoute
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash"
    }
  })], 1) : _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('remove')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("after")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b69e22","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/DataGridActions.vue
// module id = 1912
// module chunks = 0